import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            width: '100%',
            position: 'relative',
            display: 'block',
        },
        customInputContainer: {
            position: 'relative',
            w: '100%',
            align: 'center',
        },
        customMobileInputContainer: {
            position: 'relative',
            w: '100%',
            align: 'center',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            borderRadius: 'medium.lg',
            height: remCalc(38),
            paddingLeft: remCalc(18),
        },
        customInput: {
            paddingRight: {
                base: 'small.base',
                sm: 'small.sm',
                md: 'small.md',
                lg: 'small.lg',
            },
            width: '100%',
            cursor: 'pointer',
            height: remCalc(40),
            textStyle: 'body-xsmall',
            fontWeight: 400,
            color: 'text.secondary',
            borderColor: 'border.secondary',
            _focus: {
                borderColor: 'border.secondary',
            },
        },
        defaultLabel: {
            textStyle: 'body-xsmall',
            fontWeight: 400,
            color: 'text.secondary',
        },
        activeLabel: {
            textStyle: 'body-xxsmall',
            fontWeight: 400,
            color: 'text.secondary',
            background: 'background.default',
        },
        calendarIconContainer: {
            position: 'absolute',
            right: remCalc(10),
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: 'text.default',
        },
        '.react-datepicker-wrapper': {
            width: '100%',
        },
        '.react-datepicker': {
            textStyle: 'body-small',
            borderColor: '#c9c9c9',
        },
        '.react-datepicker__header': {
            borderColor: '#c9c9c9',
        },
        '.react-datepicker__navigation-icon::before, .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow':
            {
                borderTop: 'small',
                borderRight: 'small',
                borderBottom: 0,
                borderLeft: 0,
                borderStyle: 'solid',
                borderColor: 'border.dark',
            },
        '.react-datepicker__header ': {
            backgroundColor: 'background.light-dark',
            borderColor: '#c9c9c9',
        },
        '.react-datepicker-popper': {
            zIndex: 10,
            marginLeft: {
                base: remCalc(30),
                sm: remCalc(30),
                md: 0,
                lg: 0,
            },
        },
        '.react-datepicker__triangle': {
            borderColor: '#c9c9c9',
        },
    },
    variants: {
        success: {
            customInput: {
                borderColor: 'border.success !important',
                _hover: {
                    borderColor: 'border.success !important',
                },
            },
        },
        error: {
            customInput: {
                borderColor: 'border.danger !important',
                _hover: {
                    borderColor: 'border.danger !important',
                },
            },
        },
        disabled: {
            customInput: {
                borderColor: 'border.disabled !important',
                pointerEvents: 'none',
                _hover: {
                    borderColor: 'border.disabled !important',
                    cursor: 'default !important',
                },
            },
        },
    },
}

// '.react-date-picker': {
//     w: '100%',
//     h: remCalc(38),
//     textStyle: 'body-xsmall',
// },
// '.react-date-picker__wrapper': {
//     borderColor: 'border.secondary',
//     _hover: {borderColor: 'border.secondary'},
//     _focus: {borderColor: 'border.secondary'},
//     borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
// },
// 'react-date-picker__calendar-button__icon': {
//     stroke: 'border.light',
// },
// '.react-date-picker__inputGroup': {
//     paddingLeft: remCalc(16),
// },
// '.focus-visible': {
//     outline: 'none',
// },
// '.react-date-picker__button svg': {
//     stroke: 'border.secondary',
// },
